<template>
  <div>
    <div v-if="surfaceGrade.status === undefined">
      <div class="box_title">
        <b>{{ surfaceGrade.stuName }}的创业计划书情况</b>
      </div>
      <n-table :bordered="true" :single-line="false" style="text-align: center">
        <tbody>
          <tr>
            <td>姓名: </td>
            <td>{{ surfaceGrade.stuName }}</td>
            <td>联系方式: </td>
            <td colspan="2" style="width: 800px">{{ surfaceGrade.mobilePhone }}</td>
            <!--          <td>学时</td>-->
          </tr>
          <tr>
            <td>身份证号: </td>
            <td>{{ surfaceGrade.idNumber }}</td>
            <td>二维码名称: </td>
            <td colspan="2">{{ surfaceGrade.qrCodeName }}</td>
            <!--          <td>{{ item.period }}</td>-->
          </tr>
          <tr>
            <td rowspan="2">评价指标及分值 : </td>
            <td colspan="2" rowspan="2">评价标准 </td>
            <!-- <td></td> -->
            <td style="height: 30px" colspan="2">评价分数 : </td>
            <!-- <td></td> -->
          </tr>
          <tr>
            <!-- <td></td> -->
            <!-- <td></td> -->
            <!-- <td></td> -->
            <td style="height: 30px">{{ surfaceGrade.expertNameOne }}</td>
            <td>{{ surfaceGrade.expertNameTwo }}</td>
          </tr>
          <tr v-for="(item, index) of surfaceGrade.reviewScoreVOtwo" :key="index">
            <td>{{ item.target }}</td>
            <td align="left" colspan="2"> <div v-html="item.content"></div> </td>
            <!-- <td></td> -->
            <td>{{ item.fraction }}</td>
            <td>{{ item.fractionTwo }}</td>
          </tr>
          <tr>
            <td rowspan="2">得分合计 </td>
            <td colspan="2">{{ surfaceGrade.expertNameOne }}</td>
            <!-- <td></td> -->
            <td colspan="2">{{ surfaceGrade.expertNameTwo }}</td>
            <!-- <td></td> -->
          </tr>
          <tr>
            <!-- <td></td> -->
            <td colspan="2">{{ surfaceGrade.totalScoreOne }}</td>
            <!-- <td></td> -->
            <td colspan="2">{{ surfaceGrade.totalScoreTwo }}</td>
            <!-- <td></td> -->
          </tr>
          <tr>
            <td>评委签字</td>
            <td colspan="2">
              <el-image
                v-if="surfaceGrade.signatureOne !== ''"
                style="width: 120px; line-height: 60px"
                align="center"
                :src="surfaceGrade.signatureOne"
                :preview-src-list="[surfaceGrade.signatureOne]"
              >
              </el-image>
              <div v-else>---</div>
            </td>
            <!-- <td></td> -->
            <td colspan="2">
              <el-image
                v-if="surfaceGrade.signatureTwo !== ''"
                style="width: 120px; line-height: 60px"
                align="center"
                :src="surfaceGrade.signatureTwo"
                :preview-src-list="[surfaceGrade.signatureTwo]"
              >
              </el-image>
              <div v-else>---</div>
            </td>
            <!-- <td></td> -->
          </tr>
          <tr>
            <td>综合评定</td>
            <td colspan="4">{{ surfaceGrade.reviewStatusName }}</td>
            <!-- <td></td>
          <td></td>
          <td></td> -->
          </tr>
          <tr>
            <td>评审日期</td>
            <td colspan="4">{{ surfaceGrade.reviewTime }}</td>
            <!-- <td></td>
          <td></td>
          <td></td> -->
          </tr>
          <tr>
            <td>专家评语</td>
            <td colspan="2">{{ surfaceGrade.reviewCommentOne }}</td>
            <!-- <td></td> -->
            <td style="width: 245px" colspan="2">{{ surfaceGrade.reviewCommentTwo }}</td>
            <!-- <td></td> -->
          </tr>
        </tbody>
      </n-table>
    </div>
    <div v-else>
      <n-empty description="暂无评审"> </n-empty>
    </div>
  </div>
</template>

<script>
import { reviewDetail } from '@/api';
import { ref } from 'vue';
export default {
  props: {
    msgPS: String,
  },
  setup(props, { emit }) {
    // 父组件传的值 props
    console.log(props.msgPS);
    // 数据
    const surfaceGrade = ref({});
    const imgBaseUrl = 'https://qingjuck.oss-cn-shanghai.aliyuncs.com/';

    reviewDetail({ stuId: props.msgPS }).then(res => {
      // console.log('@@@@@@@@@@@@@');
      // console.log(res);
      surfaceGrade.value = res;
      if (surfaceGrade.value.signatureOne !== '') {
        surfaceGrade.value.signatureOne = imgBaseUrl + res.signatureOne;
      }
      if (surfaceGrade.value.signatureTwo !== '') {
        surfaceGrade.value.signatureTwo = imgBaseUrl + res.signatureTwo;
      }

      if (surfaceGrade.value.data === undefined) {
        console.log('有数据');
        console.log(surfaceGrade.value.status);
      } else {
        console.log('没数据');
        console.log(surfaceGrade.value.status);
      }
    });

    return { surfaceGrade };
  },
};
</script>

<style lang="scss" scoped>
.box_title {
  font-size: 20px;
  height: 60px;
  line-height: 30px;
  text-align: center;
}
</style>
